import type { Track } from "libs/audio-player";
import { create } from "zustand";

type PlayerPosition = {
	x: number;
	y: number;
};

type PodcastPlayerState = {
	visible: boolean;
	currentTrackInfo: Track | null;
	playerPosition: PlayerPosition | null;
	showGlobalPlayer: boolean;
	isPlaying: boolean;
	endOfQueue: boolean;
	isFirstTrack: boolean;
	setIsPlaying: (isPlaying: boolean) => void;
	setVisible: (visible: boolean) => void;
	setCurrentTrackInfo: (info: Track | null) => void;
	updatePlayerPosition: (position: PlayerPosition) => void;
	setShowGlobalPlayer: (show: boolean) => void;
	setEndOfQueue: (endOfQueue: boolean) => void;
	setIsFirstTrack: (isFirstTrack: boolean) => void;
};

export const usePodcastPlayerStore = create<PodcastPlayerState>((set) => ({
	visible: false,
	currentTrackInfo: null,
	playerPosition: null,
	showGlobalPlayer: true,
	isPlaying: false,
	endOfQueue: false,
	isFirstTrack: false,
	setIsPlaying: (isPlaying) => set({ isPlaying }),
	setEndOfQueue: (endOfQueue) => set({ endOfQueue }),
	setVisible: (visible) => set({ visible }),
	setCurrentTrackInfo: (info) => set({ currentTrackInfo: info }),
	updatePlayerPosition: (position) => {
		set({ playerPosition: position });
	},
	setShowGlobalPlayer: (show) => set({ showGlobalPlayer: show }),
	setIsFirstTrack: (isFirstTrack) => set({ isFirstTrack }),
}));
